export default __webpack_public_path__ + "static/lonnie-ebbe445a8e6aa6afcc32e10fcd820640.png";